import React from "react";

function BS4_GridMedium() {
  return (
    <div>
      <h1>BS4_GridMedium Component</h1>
      <p>This is the BS4_GridMedium tutorial page content.</p>
    </div>
  );
}

export default BS4_GridMedium;
